// extracted by mini-css-extract-plugin
module.exports = {"icon":"UserIcon_icon__3Kn8X","isOnline":"UserIcon_isOnline__1bTcQ"};